/**
 * Геометрія оболонки (layout.md, розд. 3; tokens.css: --cl-nav-rail-w, --cl-nav-expanded-w,
 * --cl-today-panel-w) для оцінок ДО першого виміру: читання розмірів з DOM під час рендеру змусило
 * б браузер синхронно рахувати розкладку. Оцінку завжди уточнює ResizeObserver.
 */

import { getPrefs, type NavMode } from '../prefs/prefs.ts';
import { isNavExpanded, NAV_EXPANDED_FROM, normalizeNavMode } from './nav-mode.ts';

/** Від цієї ширини вікна «Сьогодні» стоїть поруч зі списком; вужче — накладна. */
export const WIDE = 1280;
const PHONE_BELOW = 600;
const NAV_W = { rail: 64, expanded: 224 } as const;
const ASIDE_W = 320;
/** Смуга прокрутки на Windows — еталонний ПК (reference-pc.md); на macOS вона накладна, 0 px. */
const SCROLLBAR_W = 17;

/**
 * Оцінка ширини вмісту робочої області: вікно мінус навігація (з урахуванням закріпленого
 * вигляду), «Сьогодні» поруч і смуга прокрутки.
 */
export function estimateContentWidth(
  asideOpen: boolean,
  viewport = window.innerWidth,
  navMode: NavMode = normalizeNavMode(getPrefs().nav),
): number {
  const expanded = isNavExpanded(navMode, viewport >= NAV_EXPANDED_FROM);
  const nav = viewport < PHONE_BELOW ? 0 : expanded ? NAV_W.expanded : NAV_W.rail;
  const aside = asideOpen && viewport >= WIDE ? ASIDE_W : 0;
  return Math.max(0, viewport - nav - aside - SCROLLBAR_W);
}
